import React, { Dispatch, SetStateAction, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { commonString } from "../../../../AdminApi/commFunc";
import { useApi } from "../../../../hooks/useApi";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import SearchDropdown from "../../../Filters/SearchDropdown";
import { PartyInfoFilterContainer } from "../../Party/PartyInfo/PartyInfoFilter";

interface ManageFaqFilterProps {
  setSearchValue: Dispatch<SetStateAction<string | undefined>>;
  faqFilter: {
    category: number;
    keyword: string;
    orderByViewCount: number;
  };
  setFaqFilter: Dispatch<
    SetStateAction<{
      category: number;
      keyword: string;
      orderByViewCount: number;
    }>
  >;
  setPage: Dispatch<SetStateAction<number>>;
}

export default function ManageFaqFilter({
  setSearchValue,
  faqFilter,
  setFaqFilter,
  setPage,
}: ManageFaqFilterProps) {
  const { pathname } = useLocation();

  const [searchKeyword, setSearchKeyword] = useState<string | undefined>("");
  const [keywordBoxClick, setKeywordBoxClick] = useState(false);
  const [keywordList, setKeywordList] = useState<OptionType[]>([]);
  const [keywordDropdown, setKeywordDropdown] = useState<OptionType>({
    value: "",
    label: "키워드 검색",
  });

  const [categoryBoxClick, setCategoryBoxClick] = useState(false);
  const [categoryList, setCategoryList] = useState<OptionType[]>([]);
  const [categoryDropdown, setCategoryDropdown] = useState<OptionType>({
    value: "",
    label: "카테고리 선택",
  });

  // console.log(keywordDropdown);

  // 카테고리 리스트
  const { response, loading } = useApi({
    method: "get",
    url: categoryBoxClick
      ? `category?type=${commonString(pathname).type ?? 0}`
      : undefined,
  });

  // 키워드 리스트
  const { response: keywordResponse, loading: keywordLoading } = useApi({
    method: "get",
    url: keywordBoxClick ? `FAQ/keyword` : undefined,
  });

  useEffect(() => {
    if (response?.status === 200 || keywordResponse?.status === 200) {
      // setCategoryBoxClick(false);
      const serverList: { id: string; name: string }[] =
        response?.data ?? keywordResponse?.data;

      let dropdownList = [];

      for (let i = 0; i < serverList.length; i++) {
        const el = serverList[i];

        dropdownList.push({
          value: `${el.id}`,
          label: `${el.name}`,
        });
      }

      if (response?.status === 200) {
        setCategoryList(dropdownList);
      } else {
        setKeywordList(dropdownList);
      }
    }
  }, [response, keywordResponse]);

  useEffect(() => {
    if (keywordDropdown?.value !== "") {
      setSearchValue(keywordDropdown?.value);
    }
  }, [keywordDropdown?.value]);

  useEffect(() => {
    if (searchKeyword !== "") {
      console.log("✅", Number(searchKeyword));

      setFaqFilter({
        ...faqFilter,
        keyword: isNaN(Number(searchKeyword)) ? "0" : searchKeyword!,
      });
    }
  }, [searchKeyword]);

  return (
    <>
      <ManageFaqFilterContainer>
        <div onClick={() => setKeywordBoxClick(true)}>
          <SearchDropdown
            placeholder="키워드 검색"
            searchValue={searchKeyword}
            setSearchValue={setSearchKeyword}
            keywordList={keywordList}
          />
        </div>

        <Flex gapSize={10}>
          <FilterIcon maxWidth={1200} />

          <div onClick={() => setCategoryBoxClick(true)}>
            <DropDown
              dropdownValue={categoryDropdown}
              setDropDownValue={setCategoryDropdown}
              optionList={categoryList}
              boxWidth={180}
            />
          </div>

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            isDisabled={categoryDropdown?.value === ""}
            btnClickEvent={() => {
              setPage(0);
              setFaqFilter({
                ...faqFilter,
                category: Number(categoryDropdown?.value ?? 0),
              });
            }}
          />

          <LineBtn
            btnText="초기화"
            icon="refresh"
            btnHeight={38}
            btnColor="mint"
            disabled={categoryDropdown?.value === ""}
            btnClickEvent={() => {
              setCategoryDropdown({
                value: "",
                label: "카테고리 선택",
              });
              setFaqFilter({
                orderByViewCount: 0,
                keyword: "",
                category: 0,
              });
            }}
          />

          <LineBtn
            btnText="조회순"
            icon="filter_list"
            btnHeight={38}
            sPadding={"10px 12px 10px 10px"}
            btnClickEvent={() => {
              setPage(0);
              setFaqFilter({
                ...faqFilter,
                orderByViewCount: 1,
              });
            }}
          />
        </Flex>
      </ManageFaqFilterContainer>

      {(loading || keywordLoading) && <Loader />}
    </>
  );
}

export const ManageFaqFilterContainer = styled(PartyInfoFilterContainer)`
  @media screen and (max-width: 1400px) {
    flex-direction: row;
  }

  @media screen and (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
